import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from './components/Hero';
import CategoryIndex from './components/CategoryIndex';
import HotRanking from './components/HotRanking';
import FeaturedCollections from './components/FeaturedCollections';
import CategorySummary from './components/CategorySummary';
import LatestUpdates from './components/LatestUpdates';
import FaqSection from './components/FaqSection';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <Hero />
        <CategoryIndex />
        <HotRanking />
        <FeaturedCollections />
        <CategorySummary />
        <LatestUpdates />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}